<template>
    <div class="flex flex-1 flex-col">
        <Link :href="route('posts.show', { user: post.user.username, post: post.id })" class="group">
            <div class="relative mx-auto w-full h-48 bg-white bg-opacity-50 overflow-hidden sm:h-56">
                <div class="aspect-w-10 aspect-h-5 group-hover:opacity-80" v-html="post.featuredImageHtml"></div>
                <div class="group absolute left-3 top-3 flex flex-col items-center px-5 py-2 text-sky-700 font-display text-2xl font-bold bg-white bg-opacity-80 rounded-lg shadow-lg sm:py-2 sm:text-4xl">
                    <div class="currency inline-flex leading-none">{{ post.pledgedAmount | abbr }}</div>
                    <span class="text-sky-600 font-display text-xs font-bold leading-none uppercase sm:text-sm sm:leading-none">Pledged</span>
                </div>
            </div>

            <!--<div class="flex items-center px-5 mt-3 h-16">-->
            <!--    <dl>-->
            <!--        <dt class="sr-only">Challenge Details</dt>-->
            <!--        <dd class="text-gray-700 text-sm line-clamp-3">{{ post.text }}</dd>-->
            <!--    </dl>-->
            <!--</div>-->
        </Link>

        <!-- LikeLikeable, Comments, Share -->
        <div class="flex items-center justify-between my-2 px-2">
            <div class="flex items-center text-gray-500 text-sm leading-5 space-x-2">
                <!-- LikesLikeables -->
                <like :likeable="post"></like>

                <span class="text-gray-500 font-medium">&middot;</span>

                <!-- Comments -->
                <div class="has-tooltip">
                    <Link :href="post.showUrl" class="group flex items-center space-x-1">
                        <svg class="w-6 h-6 text-gray-500 group-hover:text-gray-700 font-medium" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        </svg>
                        <div class="flex-shrink-0 group-hover:text-gray-700">{{ post.commentsCount }}</div>
                    </Link>
                    <tooltip v-if="post.commentsCount">Show {{ post.commentsCount | abbr }} {{ "comment" | pluralize(post.commentsCount) }} </tooltip>
                </div>
            </div>

            <!-- Share Post -->
            <button class="inline-flex items-center px-2 hover:text-blue-500 focus:text-blue-500 text-gray-500 rounded-sm focus:outline-none space-x-2 focus:ring-1 focus:ring-blue-500 focus:ring-offset-2" @click="showShareModal = true">
                <!-- Heroicon name: solid/share -->
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                    />
                </svg>
                <span class="text-sm font-medium">Share</span>
            </button>
        </div>

        <!-- Share Modal: this should probably be taken out of the loop -->
        <share-modal :post="post" :show.sync="showShareModal" />
    </div>
</template>

<script>
import ShareModal from "@/Components/ShareModal"
import Tooltip from "@/Components/Tooltip"
import Like from "@/Components/Like"

export default {
    components: { Like, Tooltip, ShareModal },
    props: {
        post: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            showShareModal: false,
        }
    },
}
</script>
